/**
 * Gate del flujo POS: si el cajero no tiene un terminal pareado en localStorage,
 * lo redirige a /select-terminal antes de dejarlo operar.
 *
 * Solo aplica a los cajeros — los admins no pasan por acá (su flujo va por
 * RequireRole bajo /admin).
 */

import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useTerminalStore } from "@/stores/terminal.ts";

interface Props {
  children: ReactNode;
}

export function RequireTerminal({ children }: Props) {
  const terminal = useTerminalStore((s) => s.terminal);
  if (!terminal) {
    return <Navigate to="/select-terminal" replace />;
  }
  return <>{children}</>;
}
